import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WatermarkPreviewSettingsComponent } from './watermark-preview-settings.component';

@NgModule({
  imports: [CommonModule, WatermarkPreviewSettingsComponent],
  exports: [WatermarkPreviewSettingsComponent],
})
export class WatermarkPreviewSettingsModule {}
